import { serviceApi } from '~/features/QueryClient';

export async function novaSenha(
  email: string,
  password: string
): Promise<void> {
  await serviceApi.put('/Usuario/NovaSenha', { email, password });
}
